// extracted by mini-css-extract-plugin
export var videoWrapper = "video-module--videoWrapper--v7XLv";
export var videoPlayButton = "video-module--videoPlayButton--VkYwt";
export var video = "video-module--video--dn-06";
export var videoPlaying = "video-module--videoPlaying--gweOF";